import React, { createContext, useContext } from 'react';
import useFloatingTimer from '../hooks/useFloatingTimer';

const FloatingTimerContext = createContext();

export const useFloatingTimerContext = () => {
  const context = useContext(FloatingTimerContext);
  if (!context) {
    throw new Error('useFloatingTimerContext deve ser usado dentro de um FloatingTimerProvider');
  }
  return context;
};

export const FloatingTimerProvider = ({ children }) => {
  const floatingTimer = useFloatingTimer();

  return (
    <FloatingTimerContext.Provider value={floatingTimer}>{children}</FloatingTimerContext.Provider>
  );
};
